// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Add",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.85 17.79h10.33v10.38c0 1.01.82 1.82 1.82 1.82s1.82-.82 1.82-1.82V17.84h10.33c1.01 0 1.82-.82 1.82-1.82s-.82-1.82-1.82-1.82H17.82V3.82C17.82 2.81 17 2 16 2s-1.82.82-1.82 1.82v10.33H3.85c-1.01 0-1.82.82-1.82 1.82s.82 1.82 1.82 1.82"
    })
  });
};